export const enum AppRoutes {
  Home = '/',
  Prequalification = '/prequalification',
  AcceptTermsOfUse = '/accept-terms-of-use',
  Disclosure = '/disclosure',
  AcknowledgementAndConsent = '/acknowledgement-and-consent',
  Login = '/login',
  Dashboard = '/dashboard',
  TranscriptAuthorization = '/transcript-authorization',
  ResetPassword = '/reset-password/:token',
  IdentityVerification = '/identity-verification',
  CompleteAuthentication = '/complete-auth',
  CompleteMobileAuthentication = '/complete-mobile-auth',
  ContractorPortal = '/contractor-portal',
  LoanPortal = '/loan-portal',
  OfferProcessing = '/offer-processing',
  Other = '*',
  TermOfUse = '/term-of-use',
  PrivacyPolicy = '/privacy-policy',
  Error = '/error',
  NotQualified = '/not-qualified',
  PasswordProtection = '/password-protection',
  ValidationSession = '/validation-session',
  MasterDealerAgreement = '/master-dealer-agreement',
}
